<template>
  <div class="mkt-form-step">
    <md-card-header>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-avatar class="md-avatar-icon step-content-num">3</md-avatar>
          <!-- <span class="card-title">Create Condition Sets </span> -->
          <div class="md-title">Create Condition Sets</div>
        </div>
        <div class="md-layout-item" style="text-align:right">
          <md-menu md-size="medium" md-align-trigger>
            <md-button
              class="md-dense md-raised md-primary mkt-btn-add-condition"
              md-menu-trigger
              style="margin-right: 10px;"
            >
              <span class="add-condition-symbol">+</span>
              <span class="txt-field">ADD CONDITION SET</span>
            </md-button>
            <md-menu-content>
              <md-menu-item @click="set_new()">NEW</md-menu-item>
              <md-menu-item
                v-for="(item , index) in value.sets"
                @click="set_duplicate(item)"
                :key="`menu_${index}`"
              >Duplicate SET
                <span v-if="item.name!=''">{{item.name}}</span>
                <span v-else>{{(index+1)}}</span>
              </md-menu-item>
            </md-menu-content>
          </md-menu>
        </div>
      </div>
    </md-card-header>

    <md-card-content style="height:calc(100vh - 200px);">
      <md-tabs :md-active-tab="this.selectTab">
        <md-tab
          style="height:calc(100vh - 250px);overflow-y:auto;overflow-x:hidden"
          v-for="(item , index) in value.sets"
          v-bind:key="index"
          :id="`tab-${index}`"
          :md-label="(item.name == '' ? `SET ${(index+1)}` : item.name)"
        >
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <!-- left-->
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field md-inline>
                    <label>SET {{index+1}}</label>
                    <md-input v-model="item.name" @change="name_add(index,item.name)"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item" style="text-align:right">
                  <div class="mktops-btn-close">
                    <md-menu md-size="medium" :md-offset-x="127" :md-offset-y="-36">
                      <md-button
                        class="md-icon-button mktops-float-right"
                        md-menu-trigger
                        style="margin-left: 25px;"
                      >
                        <md-icon>more_vert</md-icon>
                      </md-button>
                      <md-menu-content>
                        <md-menu-item @click="set_duplicate(item)">
                          <span style="color: #000000;">Duplicate</span>
                        </md-menu-item>
                        <md-menu-item @click="set_reset(index)">
                          <span style="color: #000000;">Reset</span>
                        </md-menu-item>
                        <md-menu-item @click="set_delete(index)" v-if="index != 0">
                          <span style="color: #000000;">Delete</span>
                        </md-menu-item>
                      </md-menu-content>
                    </md-menu>
                  </div>
                </div>
              </div>

              <!-- <div class="md-layout md-gutter">
                                <div class="md-layout-item md-size-25 txt-field" >Set Conditions</div>
                                <div class="md-layout-item">
                                    <md-menu md-size="medium">
                                        <md-button class="md-primary" md-menu-trigger >+ Add Condition</md-button>
                                        <div>
                                            <md-menu-content>
                                                <md-menu-item v-for="(menu,menu_index) in menuConditions" :key="menu_index" @click="condition_new(menu,item)"><span>{{menu}}</span></md-menu-item>
                                            </md-menu-content>
                                        </div>
                                    </md-menu>
                                </div>
              </div>-->
              <div
                style="margin-left:20px;padding-left:10px;border-left: 3px solid #D9D9D9;margin-bottom:20px;"
              >
                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-size-25 txt-field">Set Amount</div>
                  <div class="md-layout-item">
                    <div style="display:inline-block">
                      <!-- <md-field class="input" style="display:inline-block;min-height:16px;">
                                          <md-input class="input" v-model="item.point.start"></md-input>
                                        </md-field> 
                      -->
                      <md-field
                        class="input"
                        style="display:inline-block;min-height:16px;border-bottom:1px solid black !important;">
                        <md-input v-model="item.point.end" @keypress="validate($event)"></md-input>
                      </md-field>

                      <!-- <md-field clss="input-point" style="width:40px;">
                                              <md-input v-model="item.point.start" min="0" placeholder="Point Start" @keydown="pointHandler($event)"></md-input>
                                          </md-field>
                                          <md-field clss="input-point">
                                              <md-input v-model="item.point.end" min="0" placeholder="Point End" @keydown="pointHandler($event)"></md-input>
                      </md-field>-->
                    </div>
                  </div>
                </div>

                <div class="md-layout md-gutter">
                  <div class="md-layout-item txt-field"><md-checkbox class="md-primary" v-model="item.oneRound"> Play 1 round</md-checkbox></div>
                </div>


              </div>

              <!-- <div v-if="value.hasOwnProperty('rank_value')" style="margin-left:20px;padding-left:10px;border-left: 3px solid #D9D9D9;margin-bottom:20px;">
                                <div class="md-layout md-gutter">
                                    <div class="md-layout-item md-size-75"><span class="txt-field">Rank Require</span>

                                        <div>
                                                <RankValue v-model="value.rank_value"></RankValue>
                                            </div>

                                    </div>
                                    
                                    <div class="md-layout-item md-size-10">
                                        <md-button @click="form_delete(item,'rank')" class="md-icon-button mktops-float-right">
                                            <md-icon>close</md-icon>
                                        </md-button>
                                    </div>
                                </div>
              </div>-->

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 txt-field">Set Rewards</div>
                <div class="md-layout-item">
                  <md-button
                    class="md-primary"
                    md-menu-trigger
                    style="margin-left: 41px;"
                    @click="reward_new(item,index)"
                  >+ Add Reward</md-button>
                  <!-- <md-menu md-size="medium" v-if="!item.rewards || item.rewards.length == 0">
                                        <md-button class="md-primary" md-menu-trigger style="margin-left: 41px;">+ Add Reward</md-button>
                                        <md-menu-content>
                                            <md-menu-item v-for="(menu,menu2_index) in menuRewards" :key="menu2_index" @click="reward_new(item,index)"><span>{{menu}}</span></md-menu-item>
                                        </md-menu-content>
                  </md-menu>-->
                </div>
              </div>

              <div
                v-if="item.rewards && item.rewards.length > 0"
                style="margin-left:20px;padding-left:10px;border-left: 3px solid #D9D9D9;"
              >
                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-size-25 txt-field">Reward</div>
                  <div class="md-layout-item">
                    <div
                      class="free-items-box"
                      v-for="(data,index_rewards) in item.rewards"
                      :key="index_rewards"
                    >
                      <div class="md-layout">
                        <div class="md-layout-item">
                          <img class="imgItem" :src="data.image">
                        </div>
                        <div class="md-layout-item right">
                          <div class="title">Product Name</div>
                          <div class="data">{{data.name}}</div>
                          <div class="title">ESTIMATE COST</div>
                          <div class="data">{{data.qty}}</div>
                          <div class="title" v-if="data.sendDate">SEND DATE</div>
                          <div class="data" v-if="data.sendDate">{{data.sendDate}}</div>
                          <md-button
                            class="btn-remove"
                            @click="removeFreeItem(index_rewards,item.rewards)"
                          >
                            <font color="red">Remove</font>
                          </md-button>
                        </div>
                      </div>
                    </div>

                    <!-- <div v-if="item.rewards.length == 0">
                                            <button class="btnSelectItem" @click="openDialogFreeItem(index)">ADD</button>
                    </div>-->
                  </div>
                  <!-- <div class="md-layout-item">
                                        <md-button @click="reward_delete(item)" class="md-icon-button mktops-float-right">
                                            <md-icon>close</md-icon>
                                        </md-button>
                  </div>-->
                </div>
              </div>
            </div>
            <div class="md-layout-item md-size-35">
              <!-- right-->
              <div
                style="font-family: Roboto; font-weight: 500; font-size: 16px; color: #000000;"
              >Select Customer Group</div>

              <div style="margin-top: 8px;">
                <multiselect
                  v-model="selectedCustomerGroup"
                  id="ajax"
                  label="group_name"
                  track-by="group_name"
                  placeholder="Type to search customer group."
                  open-direction="bottom"
                  :options="dataCustomerGroup"
                  :multiple="false"
                  :searchable="true"
                  :loading="isLoadingCustomerGroup"
                  :close-on-select="true"
                  :options-limit="300"
                  :max-height="600"
                  :show-no-results="true"
                  :show-labels="false"
                  @search-change="asyncFindCustomerGroup"
                  @select="onSelect($event,index)"
                >
                  <template slot="singleLabel" slot-scope="{ props }">
                    <strong>{{ props }}</strong>
                  </template>
                  <span slot="noResult">Not found products.</span>
                </multiselect>
              </div>

              <div :id="'div_result_'+index" style="margin-top: 8px;">
                <div style="display: inline-grid">
                  <md-chip
                    class="md-primary"
                    style="margin-top: 8px; margin-left: 0px;"
                    md-deletable
                    v-for="(item_customer , index_customer) in item.customers"
                    :key="'customer_'+index_customer"
                    @click="customer_delete(index,index_customer)"
                  >{{ item_customer.group_name }}</md-chip>
                </div>
              </div>
            </div>
          </div>
        </md-tab>
      </md-tabs>
    </md-card-content>

    <dialogFreeItem ref="rewardItem" v-model="free_item" v-on:addRewards="addRewards"></dialogFreeItem>
  </div>
</template>

<script>
import campaignService from "@/services/campaign";
import customerGroupService from "@/services/customer_group";

import Rank from "../../share/rank";
import RankValue from "../../share/rank-value";
import dialogFreeItem from "@/components/campaign/share/dialogFreeItem";
import Multiselect from "vue-multiselect";

var _ = require("lodash");

export default {
  name: "campaign-step3",
  components: {
    Rank,
    RankValue,
    dialogFreeItem,
    Multiselect
  },
  props: ["value"],
  watch: {
    value() {
      console.log(this.value);
    }
  },
  data() {
    return {
      sets: {
        name: "",
        rewards: [],
        customers: [],
        //   customerGroups:[],
        freeitems: [],
        point: { start: null, end: null },
        oneRound: false
      },
      menuConditions: ["Rank"],
      menuRewards: ["Reward"],
      purchase_array: [],
      product_array: [],
      payment_array: [],
      selectTab: 0,
      free_item: [],
      selectSet: 0,

      customers: [],
      rewards: [],

      selectedCustomerGroup: [],
      dataCustomerGroup: [],
      isLoadingCustomerGroup: false,
      tempCustomer: []
    };
  },
  created() {
    customerGroupService.listAll().then(response => {
      console.log("customer", response);
      this.dataCustomerGroup = response;
      //console.log(response);
      //this.isLoading = false;
    });
    // console.log('get customer group')
    // campaignService
    //     .getCustomerGroups()
    //     .then(response => {
    //         this.customerGroups = response;
    //       //commit("setCustomerGroups", response);
    //     })
    //     .catch(error => console.log(error));
    //     this.$forceUpdate();
  },
  methods: {
    onSelect(select, index) {
      // console.log(this.value.sets)
      // console.log(e,select);
      // console.log(select);
      //this.sets[index].customers.push(select);

      if (this.value.sets[index]) {
        //this.customers.push(select);

        let temp_index = this.tempCustomer.findIndex(
            el => el.set_index == index && el.customergroup_id == select._id
        );

        if(temp_index == -1)
        {

        }else{
          this.tempCustomer.splice(temp_index, 1)
        }

        this.value.sets[index].customers.push({
          id: select._id,
          group_name: select.group_name
        });

      }

      console.log('temp customer',this.tempCustomer)
    },

    asyncFindCustomerGroup(query) {
      // this.isLoading = true;
      // customerGroupService.listAll().then(response => {
      //     console.log("customer ", response);
      //     // this.dataCustomerGroup = response;
      //     //console.log(response);
      //     //this.isLoading = false;
      // });
    },
    // asyncFindCustomerGroup(query) {
    //     this.isLoading = true;
    //     customerGroupService.searchGroup(query).then(response => {
    //         //console.log(response);
    //         this.dataCustomerGroup = response;
    //         //console.log(response);
    //         //this.isLoading = false;
    //     });
    // },
    customerGroups() {},
    set_new() {
      let index = this.value.sets.length + 1;

      this.sets.name = "SET " + index;

      let objCopy = _.cloneDeep(this.sets); //Object.assign({}, this.sets);
      this.value.sets.push(objCopy);
    },
    set_reset(index) {
      console.log(this.value.sets[index]);
      //this.value.sets[index] = Object.assign({}, this.sets);
    },
    set_duplicate(obj) {
      let objCopy = _.cloneDeep(obj);
      this.value.sets.push(objCopy);
    },
    set_delete(index) {
      delete this.value.sets.splice(index, 1);
      this.$forceUpdate();
      setTimeout(() => {
        this.selectTab = "tab-0";
      }, 50);
    },
    pointHandler(e) {
      console.log(e.keyCode);
      if ([69, 107, 109, 110, 189, 190].includes(e.keyCode)) {
        e.preventDefault();
      }
    },
    keyHandler() {},
    form_delete(obj, key) {
      delete this.value["rank_value"];
      this.$forceUpdate();
      // console.log(obj)
    },
    condition_new(obj, item) {
      if (obj == "Rank") {
        // let rank = {
        //   purchase: { A: false, B: false, C: false, D: false },
        //   product: { A: false, B: false, C: false, D: false },
        //   payment: { A: false, B: false, C: false, D: false }
        // };

        this.value.rank_value = {
          purchase: {
            selected: true,
            start: 1,
            end: 0
          },
          product: {
            selected: false,
            start: 1,
            end: 0
          },
          payment: {
            selected: false,
            start: 1,
            end: 0
          }
        };

        console.log(this.value);

        this.$forceUpdate();

        //item.push(rank);
        //this.value.sets[index]
      }
    },
    openDialogFreeItem(index) {
      this.$refs.rewardItem.showDialog = true;
      //this.$refs.rewardItem.index = 0;
      this.selectSet = index;

      //console.log(this.selectSet);
    },
    addRewards(reward, index) {
      console.log(reward);

      this.value.sets[this.selectSet].rewards.push(reward);

      this.$forceUpdate();
    },
    reward_delete(item, key) {
      item.rewards = [];

      this.$forceUpdate();
    },
    handleFileUploads(e, index) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      this.createImage(files[0], index);
    },
    createImage(file, index) {
      var tempImage = new Image();
      var reader = new FileReader();
      let vm = this;
      reader.onload = e => {
        tempImage = e.target.result;
        // console.log("tempImage",tempImage)
        // this.$store.dispatch('cpcreate/insertFileImage', {index, tempImage})
        this.value.sets[index].badge.image = tempImage;
      };
      reader.readAsDataURL(file);
      this.$forceUpdate();
    },
    removeImage(index) {
      this.value.sets[index].badge.image = "";
      this.$forceUpdate();
      // console.log("removeImage")
      //this.$store.dispatch('cpcreate/removeFileImage', {index})
    },
    removeFreeItem(index, data) {
      data.splice(index, 1);
      this.$forceUpdate();
    },
    customer_delete(index, index_customer) {
      
      let temp_index = this.tempCustomer.findIndex(
        el => el.set_index == index && el.customergroup_id == this.value.sets[index].customers[index_customer].id
      );

      console.log('temp_index', temp_index);

      if(temp_index == -1)
      {
        this.tempCustomer.push({
          camp_id : this.value._id,
          customergroup_id : this.value.sets[index].customers[index_customer].id,
          set_index: index,
          set_name: this.value.sets[index].name
        })
      }else{

      }


      
      this.customers.splice(index_customer, 1);

      //   var index = array.indexOf(search_term);    // <-- Not supported in <IE9
      //     if (index !== -1) {
      //         array.splice(index, 1);
      //     }
      this.value.sets[index].customers.splice(index_customer, 1);

      // console.log( this.tempCustomer);
      this.value.deleteCustomer = this.tempCustomer;

      
    },
    reward_new(item, index) {
      // item.rewards = [];

      this.openDialogFreeItem(index);

      this.$forceUpdate();
    },
    validate(evt,val) {
      var theEvent = evt || window.event;

      // console.log(evt.target.value)

      // Handle paste
      if (theEvent.type === "paste") {
        key = event.clipboardData.getData("text/plain");
      } else {
        // Handle key press
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
      }


      // if(key == "."){
      //   theEvent.returnValue = false;
      //     if (theEvent.preventDefault) theEvent.preventDefault();
      // }

      if(evt.target.value != "")
      {
        let dot = (evt.target.value.split(".").length - 1)
        if (dot > 0 && key == ".") {
          theEvent.returnValue = false;
          if (theEvent.preventDefault) theEvent.preventDefault();
        }
      }

      var regex = /[0-9]|\./;
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  }
};
</script>

<style lang="scss">
.md-tabs-navigation.md-elevation-0 {
  padding-left: 0px !important;
  border-bottom: 1px solid gray;

  .md-button-content {
    font-size: 14px;
  }
}

.input-field {
  margin: 0px !important;
  padding-top: 0px !important;
  min-height: 0px !important;

  input {
    border: 2px solid red !important;
  }
}
</style>

<style lang="scss" scoped>
.md-card-content {
  padding: 0px;
}
</style>

<style lang="scss" scoped>
.md-card-header {
  height: 70px;
  .md-title {
    padding-top: 10px;
    font-size: 18px;
  }
}

.md-card-header {
  height: 70px;
  padding: 0px;

  .md-avatar-icon {
    margin-left: 20px;
    margin-top: 20px;
  }

  .md-title {
    padding-top: 25px;
    font-size: 18px;
  }

  .mkt-btn-add-condition {
    margin-top: 10px;
    margin-right: 10px;
  }
}

.free-items-box {
  width: 290px;
  height: 180px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  margin-bottom: 10px;

  .right {
    text-align: right;
    padding-right: 10px;

    .title {
      font-size: 10px;
      color: #d9d9d9;
    }

    .data {
      font-size: 16px;
      color: #000;
    }

    .btn-remove {
      font-size: 12px;
      color: red;
    }
  }
  // 	width: calc(350px);
  img {
    height: 150px;
    width: 150px;
    margin-left: 10px;
    margin-top: 10px;
  }
}

.btnSelectItem {
  border: 1px solid #a8a8a8;
  color: #3f51b5;
  background-color: white;
  padding: 8px 20px;
  font-size: 20px;
  font-weight: bold;
  width: 290px;
  height: 85px;
  cursor: pointer;
  /* width:100%; */
}

.btn-add-badge [type="file"] {
  // font-size: 100px;
  position: absolute;
  width: 100px;
  height: 100px;
  left: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}
.imageDisplay {
  width: 100px;
  height: 100px;
  height: auto;
  left: 0;
  top: 0;
  // height: auto!important;
}

.closeBtn {
  position: absolute;
  right: 0;
  z-index: 10;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn {
  width: 100px;
  height: 100px;
  border: 1px solid #707070;
  color: #3f51b5;
  background-color: white;
  padding: 8px 20px;
  //border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 16px;
  position: absolute;
  left: 0;
  top: 0;
  width: 100px;
  height: 100px;
  opacity: 0;
  cursor: pointer;
}

.txt-field {
  font-weight: bold;
}

.input-field {
  margin: 0px !important;
  padding-top: 0px !important;
  min-height: 0px !important;

  .input {
    background: red !important;
    // border-bottom: 3px soild !important;
  }
}

.input {
  font-size: 16px !important;
  padding: 3px;
  width: 90px;
  text-align: right;
  // float: right;
  display: inline;
  // border-bottom: 3px !important;

  .md-count {
    display: none !important;
  }
}

// .md-field .md-input{
//   padding:10px;
// }
.md-input {
  // border-bottom: 3px !important;
}
</style>